import { call, put, takeEvery } from 'redux-saga/effects';
import Cookies from 'universal-cookie';
import { appInitFailure, appInitSuccess, } from './appActions';
import { APP_INIT_START, CLOSE_MODAL, OPEN_MODAL, RouterPaths } from './appConstants';
import appHistory, { appHistoryPushWithSearchParams } from "./appHistory.js";
import { failurePut } from './failurePut';
import { getRequest, postRequest } from './request';
import _ from "lodash";

const browserCookies = new Cookies();

/**
 * Exchange admin impersonation login_token (from query) for a partner session cookie.
 * @returns {Generator}
 */
export function* exchangeImpersonationLoginTokenSaga() {
    const params = new URLSearchParams(window.location.search);
    const loginToken = params.get('login_token');
    if (!loginToken) {
        return;
    }

    params.delete('login_token');
    const search = params.toString();
    const nextSearch = search ? `?${search}` : '';

    try {
        const data = yield call(postRequest, '/auth/impersonate', { login_token: loginToken });
        browserCookies.set('token', data.token, { path: '/', maxAge: 60 * 60 * 24 * 365 });
        appHistory.replace({
            pathname: appHistory.location.pathname || '/',
            search: nextSearch,
        });
    } catch (e) {
        appHistory.replace({
            pathname: RouterPaths.login,
            search: nextSearch,
        });
        throw e;
    }
}

export function* appInitStartSaga() {
    try {
        yield call(exchangeImpersonationLoginTokenSaga);
        const data = yield call(getRequest, '/init');

        yield put(appInitSuccess(data));
    } catch (e) {
        yield call(failurePut, e, appInitFailure);
    }
}


export function openModalSaga({ payload }) {
    try {
        const currentPayload = _.isObject(payload) ? payload: { name: payload };
        appHistoryPushWithSearchParams({
            m: currentPayload.name,
            tab: currentPayload.tab,
        });
    } catch (e) {

    }
}

export function closeModalSaga() {
    try {
        appHistoryPushWithSearchParams({
            m: null,
            tab: null,
        });
    } catch (e) {

    }
}

export function* appSagas() {
    yield takeEvery(APP_INIT_START, appInitStartSaga);
    yield takeEvery(OPEN_MODAL, openModalSaga);
    yield takeEvery(CLOSE_MODAL, closeModalSaga);
}
